<template>
  <div class="main-wrapper">
    <filter-box @queryFilter="onSearch()" @clearFilter="onClearSearch()">
      <div class="search-content">
        <div class="search-item">
          <span class="item-label">项目名称:</span>
          <div class="item-content">
            <el-input v-model="reqParams.projectName" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="search-item">
          <span class="item-label">被检对象名称:</span>
          <div class="item-content">
            <el-input v-model="reqParams.checkObjName" placeholder="请输入"></el-input>
          </div>
        </div>
      </div>
      <div slot="handle">
        <el-button icon="el-icon-plus" type="primary" @click="addModal('新增检测项目')">新增</el-button>
      </div>
    </filter-box>
    <ex-table showPagination :data="tableData" :height="tableHeight" ref="table"
              :search-method="handleChange" border>
      <ex-table-col :width="200" prop="projectName" label="项目名称"></ex-table-col>
      <ex-table-col :width="120" prop="proTypeName" label="项目类型"></ex-table-col>
      <ex-table-col :width="180" prop="location" label="所在省市区">
        <template slot-scope="scope">
          <span>{{scope.row.location|getCodeText}}</span>
        </template>
      </ex-table-col>
      <ex-table-col :width="200" prop="projectAddr" label="项目地址"></ex-table-col>
      <ex-table-col :width="140" prop="agreementNo" label="协议(合同)编号"></ex-table-col>
      <ex-table-col :width="140" prop="preTypeName" label="防雷类别"></ex-table-col>
      <ex-table-col :width="140" prop="checkTypeName" label="检测类型"></ex-table-col>
      <ex-table-col :width="140" prop="checkObjTypeName" label="被检对象类型"></ex-table-col>
      <ex-table-col :width="160" prop="checkObjName" label="被检对象名称"></ex-table-col>
      <ex-table-col :width="140" prop="checkObjNo" label="检测单位证件号"></ex-table-col>
      <ex-table-col :width="140" prop="checkReportNo" label="检测报告编号"></ex-table-col>
      <ex-table-col :width="140" prop="checkBuildingNum" label="被检建筑物数量"></ex-table-col>
      <ex-table-col :width="80" prop="operatorPersonName" label="编制人员"></ex-table-col>
      <ex-table-col :width="80" prop="checkPersonName" label="检测人员"></ex-table-col>
      <ex-table-col :width="80" prop="reviewPersonName" label="复核人员"></ex-table-col>
      <ex-table-col :width="120" prop="checkDate" label="检测日期"></ex-table-col>
      <ex-table-col :width="80" prop="approvePersonName" label="批准人员"></ex-table-col>
      <ex-table-col :width="200" prop="checkConclusion" label="检测结论"></ex-table-col>
      <ex-table-col :width="120" prop="createTime" label="创建日期">
        <template slot-scope="scope">
          <span>{{scope.row.createTime|formatDay}}</span>
        </template>
      </ex-table-col>
      <ex-table-col :width="140" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button title="编辑" class="circle-btn" type="primary" @click="edit(scope.row)" icon="el-icon-edit" circle></el-button>
          <el-button title="下载二维码" class="circle-btn" type="success" @click="downloadPic(scope.row)" icon="el-icon-download" circle></el-button>
          <el-button title="删除" class="circle-btn" type="primary" @click="removeSubject(scope.row.id)" icon="el-icon-delete" circle></el-button>
        </template>
      </ex-table-col>
    </ex-table>
    <edit v-if="isShowEdit" :rowId="currentId" :title="currentTitle" @ok="onModalOk" @close="isShowEdit=false" :mode="editMode"></edit>
    <qr-code v-if="isShowCode" :rowId="currentId" @close="closeCode"></qr-code>
  </div>
</template>
<script>
  // import {regionData, CodeToText, TextToCode} from 'element-china-area-data';
  import {getAction, downFile,deleteAction} from "../../service/http/api";
  import pageMixin from "@/mixin/tablePage"
  import Edit from './edit'
  import Code from './code'
  export default {
    name:'DetectSubjectManagement',
    mixins:[pageMixin],
    components:{
      "edit":Edit,
      "qr-code":Code
    },
    data(){
      return{
        tableHeight: window.innerHeight - 300,
        page: 1,
        pageSize: 10,
        tableData:[],
        reqParams:{
          projectName:null,
          checkObjName:null
        },
        isShowEdit:false,
        isShowCode:false,
        currentRow:null,
        currentTitle:null,
        editMode:'new',
        url:{
          list:'/check/checkProject/list',
          remove:'/check/checkProject/delete',
          removeMore:'/check/checkProject/batchDelete'
        }
      }
    },
    methods:{
      edit(row){
        this.currentTitle = '编辑' + row.projectName ;
        this.editModal(row);
      },
      removeSubject(id){
        this.$confirm('确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteAction(this.url.remove,{id}).then(res=>{
            if(res.code===200){
              this.$message({
                message:'删除成功',
                type:"success"
              });
              this.loadData();
            }
          })
        });

      },
      /**
       * 下载二维码
       * @param row
       */
      downloadPic(row){
        this.currentId = row.id||12;
        this.isShowCode = true;
      },
      closeCode(){
        this.isShowCode = false;
        this.currentId = null;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/detect_subject_management/detect_subject_management.vue